import { SvgIcon, SvgIconProps } from '@components/shared/SvgIcon'

export function SettingsLightIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={'none'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.8054 7.62358L20.183 6.54349C19.6564 5.62957 18.4895 5.31429 17.5743 5.83869V5.83869C17.1387 6.09531 16.6189 6.16812 16.1295 6.04106C15.6401 5.91399 15.2214 5.59749 14.9656 5.16134C14.8011 4.88412 14.7127 4.56836 14.7093 4.24601V4.24601C14.7242 3.72919 14.5292 3.22837 14.1688 2.85764C13.8084 2.48691 13.3133 2.27783 12.7963 2.27805H11.5423C11.0357 2.27804 10.5501 2.47988 10.1928 2.83891C9.83547 3.19795 9.63595 3.68456 9.63839 4.19109V4.19109C9.62338 5.23689 8.77126 6.07678 7.72535 6.07667C7.40299 6.07332 7.08724 5.98491 6.81001 5.82038V5.82038C5.89484 5.29598 4.72789 5.61126 4.20132 6.52519L3.53313 7.62358C3.00719 8.53636 3.31818 9.70258 4.22878 10.2323V10.2323C4.82068 10.574 5.18531 11.2056 5.18531 11.889C5.18531 12.5725 4.82068 13.204 4.22878 13.5458V13.5458C3.31934 14.0719 3.00801 15.2353 3.53313 16.1453V16.1453L4.1647 17.2346C4.41143 17.6798 4.82538 18.0083 5.31497 18.1474C5.80456 18.2866 6.32942 18.2249 6.7734 17.976V17.976C7.20986 17.7213 7.72997 17.6515 8.21812 17.7822C8.70627 17.9128 9.12201 18.233 9.37294 18.6716C9.53748 18.9489 9.62589 19.2646 9.62924 19.587V19.587C9.62924 20.6435 10.4857 21.5 11.5423 21.5H12.7963C13.8493 21.5 14.7043 20.6491 14.7093 19.5961V19.5961C14.7069 19.088 14.9076 18.6 15.2669 18.2407C15.6262 17.8814 16.1143 17.6806 16.6224 17.6831C16.944 17.6917 17.2584 17.7797 17.5377 17.9394V17.9394C18.4505 18.4653 19.6167 18.1543 20.1464 17.2437V17.2437L20.8054 16.1453C21.0605 15.7075 21.1305 15.186 21 14.6963C20.8694 14.2067 20.549 13.7893 20.1098 13.5366V13.5366C19.6705 13.2839 19.3502 12.8665 19.2196 12.3769C19.089 11.8873 19.159 11.3658 19.4141 10.9279C19.58 10.6383 19.8202 10.3982 20.1098 10.2323V10.2323C21.0149 9.70286 21.3252 8.54346 20.8054 7.63274V7.63274V7.62358Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="12.1752"
        cy="11.889"
        r="2.63616"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
